import SlideoverWithStickyFooter from "@/app/components/ui/SlideOvers/SlideoverWithStickyFooter";
import CalendarViewFilterComponent from "../../auth_routes/StaffCalendar/CalendarFilterComponent";
import StaffCalendarQuickFilters from "../../auth_routes/StaffCalendar/StaffCalendarQuickFilters";

const CalendarViewFiltersSlideover = () => {
  return (
    <SlideoverWithStickyFooter slideoverId="CALENDAR_VIEW_FILTERS" title="Filters">
      <div className="flex justify-start  flex-col items-start">
        <StaffCalendarQuickFilters />
      </div>
      <CalendarViewFilterComponent />
    </SlideoverWithStickyFooter>
  );
};

export default CalendarViewFiltersSlideover;
